import styled from "styled-components"

export const StyledFirstStep = styled.div`
	
	.body{
		margin: 32px 72px 0 72px;

    .admission{
      &__error{
        margin-bottom: 24px;
        padding: 0;
        border-radius: 4px;


        .ant-alert-message{
          padding: 4px 24px;
        }

        .ant-alert-icon{
          padding: 14px;
          background: #DC3545;
        }
      }
    }

    ol{
      padding-left: 16px;
      padding-bottom: 8px;

      li::marker{
        color: #51258F;
        font-weight: 700;
      }
    }

    a{
      color: #009CF8 !important;

      &:hover{
        text-decoration: underline !important;
      }
    }
		

		h3{
			font-size: 20px;
			line-height: 32px;
			margin-bottom: 16px;
			font-weight: 500;
			color: #212529;
		}
		
		.ant{
			&-form{
				&-item{
					margin-bottom: 16px;
					
					
				}
			}

      &-checkbox-wrapper{
        padding-bottom: 8px;
      }
		}


    .item-border-bottom{
      margin-top: 8px;
      margin-bottom: 8px;
    }
	}
	`